import * as React from "react";

export function IntersectIcon({
  fill = "#1A2547",
  stroke = "none",
  onClick,
}: {
  fill?: string;
  stroke?: string;
  onClick?: () => void;
}): JSX.Element {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
        <path
          d="M16.6152 6.97656C18.2721 6.97656 19.6152 8.31971 19.6152 9.97656V15.6465C19.6152 17.3033 18.2721 18.6465 16.6152 18.6465H10.9453C9.28846 18.6465 7.94531 17.3033 7.94531 15.6465V13.1895H10.2666C11.9235 13.1895 13.2666 11.8463 13.2666 10.1895V6.97656H16.6152ZM10.2666 1.51953C11.9235 1.51953 13.2666 2.86268 13.2666 4.51953V6.97656H10.9453C9.28846 6.97656 7.94531 8.31971 7.94531 9.97656V13.1895H4.59668C2.93983 13.1895 1.59668 11.8463 1.59668 10.1895V4.51953C1.59668 2.86268 2.93983 1.51953 4.59668 1.51953H10.2666Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
